import { render } from "./honoreeItem.vue?vue&type=template&id=6b976309"
import script from "./honoreeItem.vue?vue&type=script&lang=js"
export * from "./honoreeItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__